import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Modal } from 'pcln-modal'
import { Flex } from 'pcln-design-system'
import Navigation from '../Navigation'
import NavHeader from '../NavHeader'
import NavLink from '../NavLink'
import {
  alignmentTypes,
  stringOrNumber,
  headerNavigationShape
} from '../../utils/shapes'

const StyledModal = styled(Modal)`
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
`
StyledModal.displayName = 'StyledModal'

const DialogContent = styled(Flex)`
  flex-direction: column;

  & > :first-child {
    border-top: 1px solid lightgray;
  }

  & > * {
    border-bottom: 1px solid lightgray;
  }
`
DialogContent.displayName = 'DialogContent'

const StyledNavLink = styled(NavLink)`
  width: 100%;
  padding: ${themeGet('space.3')}px;
`
StyledNavLink.displayName = 'StyledNavLink'

function HeaderDialog ({
  className,
  isOpen,
  logoPath,
  logoHref,
  logoTitle,
  secondaryLogoPath,
  secondaryLogoHref,
  secondaryLogoTitle,
  logoAlignment,
  height,
  iconColor,
  menuColor,
  menuHeaderColor,
  menuBackgroundColor,
  isMenuButtonRightAligned,
  dropdownColor,
  navigation,
  target,
  onClose,
  hasNavigation
}) {
  return (
    <StyledModal
      isOpen={isOpen}
      zIndex={1000}
      imgMode
      disableCloseButton
      onClose={onClose}
    >
      <NavHeader
        isOpen
        logoPath={logoPath}
        logoHref={logoHref}
        logoTitle={logoTitle}
        secondaryLogoPath={secondaryLogoPath}
        secondaryLogoHref={secondaryLogoHref}
        secondaryLogoTitle={secondaryLogoTitle}
        logoAlignment={logoAlignment}
        isMenuButtonRightAligned={isMenuButtonRightAligned}
        target={target}
        height={height}
        color={menuHeaderColor}
        backgroundColor={menuBackgroundColor}
        onClick={onClose}
        hasNavigation={hasNavigation}
      />
      <DialogContent>
        <Navigation
          color={menuColor}
          iconColor={iconColor}
          dropdownColor={dropdownColor}
          navigation={navigation}
          target={target}
        />
      </DialogContent>
    </StyledModal>
  )
}

HeaderDialog.displayName = 'HeaderDialog'

HeaderDialog.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  logoPath: PropTypes.string,
  logoHref: PropTypes.string,
  logoTitle: PropTypes.string,
  secondaryLogoPath: PropTypes.string,
  secondaryLogoHref: PropTypes.string,
  secondaryLogoTitle: PropTypes.string,
  height: stringOrNumber,
  iconColor: PropTypes.string,
  dropdownColor: PropTypes.string,
  menuColor: PropTypes.string,
  menuHeaderColor: PropTypes.string,
  menuBackgroundColor: PropTypes.string,
  isMenuButtonRightAligned: PropTypes.bool,
  logoAlignment: alignmentTypes,
  navigation: PropTypes.arrayOf(headerNavigationShape),
  target: PropTypes.string,
  onClose: PropTypes.func,
  hasNavigation: PropTypes.bool
}

HeaderDialog.defaultProps = {
  className: ''
}

export default memo(HeaderDialog)
